import { assetDetailStyles } from "@/features/assets/services/assetDetailStyles";
import { Card, CardContent, CardHeader } from "@/shared/ui/card";
import { Skeleton } from "@/shared/ui/skeleton";

export function ClientAssetDetailSkeleton() {
  return (
    <div className={assetDetailStyles.pageBackground}>
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar Skeleton */}
        <div className="w-80 border-r border-border/40 bg-gradient-to-br from-card/95 via-card/90 to-accent/5 backdrop-blur-xl">
          <div className="p-6 space-y-6">
            <Skeleton className="h-8 w-48 bg-muted/20" />
            <div className="space-y-3">
              {Array.from({ length: 10 }).map((_, i) => (
                <Skeleton key={i} className="h-10 w-full bg-muted/20" />
              ))}
            </div>
          </div>
        </div>

        {/* Main Content Skeleton */}
        <div className="flex-1 overflow-y-auto">
          {/* Header Skeleton */}
          <div className="sticky top-0 z-10 bg-gradient-to-r from-card via-card/98 to-accent/20 backdrop-blur-xl border-b border-border/50 px-6 py-4">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-accent/5 pointer-events-none" />
            <div className="relative space-y-4">
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-24 bg-muted/20" />
                <Skeleton className="h-4 w-4 bg-muted/20" />
                <Skeleton className="h-4 w-32 bg-muted/20" />
                <Skeleton className="h-4 w-4 bg-muted/20" />
                <Skeleton className="h-4 w-40 bg-muted/20" />
              </div>
              <div className="flex items-center justify-between">
                <div className="space-y-2">
                  <Skeleton className="h-8 w-64 bg-muted/20" />
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-6 w-24 bg-muted/20" />
                    <Skeleton className="h-6 w-32 bg-muted/20" />
                  </div>
                </div>
                <Skeleton className="h-10 w-10 bg-muted/20 rounded-full" />
              </div>
            </div>
          </div>

          {/* Stat Cards Skeleton */}
          <div className="px-6 py-6">
            <div className={assetDetailStyles.responsiveGrid}>
              {Array.from({ length: 4 }).map((_, i) => (
                <Card 
                  key={i} 
                  className="relative group bg-gradient-to-br from-card/80 via-card/70 to-accent/10 backdrop-blur-xl border border-border/50 shadow-xl ring-1 ring-primary/10"
                >
                  <div className="absolute -inset-0.5 bg-gradient-to-r from-primary/20 to-accent/20 rounded-xl blur-md opacity-0" />
                  <CardHeader className="relative pb-3 border-b border-border/30">
                    <div className="flex items-center justify-between">
                      <Skeleton className="h-4 w-32 bg-muted/20" />
                      <Skeleton className="h-8 w-8 bg-muted/20 rounded-lg" />
                    </div>
                  </CardHeader>
                  <CardContent className="relative pt-4">
                    <Skeleton className="h-10 w-24 bg-muted/20 mb-2" />
                    <Skeleton className="h-4 w-40 bg-muted/20" />
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Content Sections Skeleton */}
          <div className="px-6 pb-6 space-y-6">
            {Array.from({ length: 3 }).map((_, sectionIndex) => (
              <Card 
                key={sectionIndex}
                className="bg-gradient-to-br from-card/95 via-card/90 to-accent/5 backdrop-blur-xl border border-border/40 shadow-2xl ring-1 ring-primary/5"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-accent/5 pointer-events-none rounded-lg" />
                <CardHeader className="relative">
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-6 w-6 bg-muted/20 rounded" />
                    <Skeleton className="h-6 w-48 bg-muted/20" />
                  </div>
                </CardHeader>
                <CardContent className="relative space-y-4">
                  {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="flex items-center justify-between">
                      <Skeleton className="h-5 w-32 bg-muted/20" />
                      <Skeleton className="h-5 w-48 bg-muted/20" />
                    </div>
                  ))}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
